<template>
  <div class="list-card">
    <div class="list-card__header svg-on-hover" @click="active = !active">
      <span class="list-card__header--text is-flex">
        <div class="eye-icon">
          <img src="../../../../../../../../../assets/icons/eye.svg" alt="" srcset="" />
        </div>
        <div class="is-medium-16-500-19 group-name">{{ group.name }}</div>
        <svg @click.stop="delete_group()" viewBox="0 0 100 100" class="image is-24x24 ml-20 is-pointer">
          <use xlink:href="@/assets/icons/sprite.svg#delete" />
        </svg>
        <!-- <i @click.stop="delete_group()" class="fa fa-trash"></i> -->
      </span>
      <span class="list-card__header--icon is-pointer">
        <i class="fas has-text-grey" :class="[active ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
      </span>
    </div>
    <div class="list-card__body" v-if="active">
      <draggable :list="group.featureTypes" draggable=".featuretypeDrag" @end="onMove">
        <transition-group type="transition" :name="'flip-list'">
          <FeatureType
            class="featuretypeDrag"
            @onDeleteFeature="$emit('feature_type_added')"
            @feature_type_updated="$emit('feature_type_added')"
            v-for="feature_type in sort(group.featureTypes)"
            :key="feature_type.uid"
            :feature_type="feature_type"
            :color_list="color_list"
          />
        </transition-group>
      </draggable>
      <div class="list-card__body--item">
        <div class="list-card__body--item-text sh-text-normal-12">
          <a class="medium-weight new-feature" v-if="!is_create" @click="is_create = true">
            <i class="fa fa-plus mr-10"></i> {{ localization("app-new-feature-type", "New Feature Type") }}
          </a>
          <div v-if="is_create" class="field has-addons" style="position:relative">
            <div class="control has-icons-left has-icons-right">
              <input
                @keyup.enter="save"
                @click="is_color_list = !is_color_list"
                class="input is-fullwidth no-outline"
                type="text"
                v-model="form.name"
                @keyup.esc="is_create = false"
                :placeholder="localization('app-enter-name', 'Enter Name')"
              />
              <span class="icon is-small is-left is-pointer">
                <i :style="{ color: form.properties.color }" class="fas fa-circle"></i>
              </span>
              <div v-if="is_color_list" class="color-list has-text-centered">
                <i
                  v-for="(color, i) in color_list"
                  :key="i"
                  class="fa fa-circle is-pointer"
                  :style="{ color: color.color }"
                  @click="form.properties.color = color.color"
                ></i>
              </div>
            </div>
            <div class="control" :class="{'is-disabled':!form.name}">
              <svg viewBox="0 0 100 100" class="image is-32x32 ml-20 is-pointer" @click="save">
                <use xlink:href="@/assets/icons/helper_sprite.svg#tick" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FeatureType from "./feature-type";
import FeatureTypeGroupService from "@/services/feature-type-group.service";
const featureTypeGroupService = new FeatureTypeGroupService();
import FeatureTypeService from "@/services/feature-type.service";
const featureTypeService = new FeatureTypeService();
import draggable from "vuedraggable";

const color_list = [
  {
    color: "rgb(184, 37, 95)",
  },
  {
    color: "rgb(219, 64, 53)",
  },
  {
    color: "rgb(255, 153, 51)",
  },
  {
    color: "rgb(250, 208, 0)",
  },
  {
    color: "rgb(175, 184, 59)",
  },
  {
    color: "rgb(126, 204, 73)",
  },
  {
    color: "rgb(41, 148, 56)",
  },
  {
    color: "rgb(106, 204, 188)",
  },
  {
    color: "rgb(21, 143, 173)",
  },
  {
    color: "rgb(20, 170, 245)",
  },
  {
    color: "rgb(150, 195, 235)",
  },
  {
    color: "rgb(64, 115, 255)",
  },
  {
    color: "rgb(136, 77, 255)",
  },
  {
    color: "rgb(175, 56, 235)",
  },
  {
    color: "rgb(235, 150, 235)",
  },
  {
    color: "rgb(224, 81, 148)",
  },
  {
    color: "rgb(255, 141, 133)",
  },
  {
    color: "rgb(128, 128, 128)",
  },
  {
    color: "rgb(184, 184, 184)",
  },
  {
    color: "rgb(204, 172, 147)",
  },
];
export default {
  props: ["group"],
  components: {
    FeatureType,

    draggable,
  },
  data() {
    return {
      color_list: color_list,
      is_color_list: false,
      form: {
        name: "",
        properties: { color: null },
      },
      is_create: false,
      active: false,
    };
  },
  methods: {
    sort(data) {
      if (data && data.length) return _.sortBy(data, ["id"]);
      return [];
    },
    async save() {
      try {
        if (!this.form.properties.color) {
          this.$toast.open("Please select the color.");
          return;
        }
        if (this.is_edit) {
          this.is_edit = false;
          await featureTypeService
            .patch({
              uid: this.form.uid,
              body: {
                name: this.form.name,
                properties: this.form.properties,
              },
            })
            .then((res) => {
              this.$emit("feature_type_added");
            });
        } else if (this.is_create) {
          this.is_create = false;
          await featureTypeService.post({
            body: {
              ...this.form,
              featureTypeGroup: this.group.uid,
            },
          });
          (this.form = {
            name: "",
            properties: { color: null },
          }),
            // this.reset_form();
            this.$emit("feature_type_added");
        }
      } catch (err) {
        this.handleErrors(err);
      }
    },
    delete_group() {
      this.$dialog.confirm({
        type: "is-danger",
        message: `Are you sure?`,
        confirmText: "Yes",
        cancelText: "No",
        onConfirm: async () => {
          try {
            await featureTypeGroupService.unassign_from_view({
              body: { featureTypeGroups: [this.group.uid] },
              id: this.$route.params.uid,
            });
            this.$emit("feature_type_added");
            this.$toast.open("Deleted successfully!");
          } catch (err) {
            this.handleErrors(err);
          }
        },
      });
    },
    async onMove() {
      let body = {
        featureTypeUids: [],
      };
      body.featureTypeUids = this.group.featureTypes.map((element) => element.uid);
      await featureTypeService.move({ body });
    },
  },
};
</script>

<style lang="scss">
.flip-list-move {
  transition: transform 0.15s;
}
.no-move {
  transition: transform 0s;
}
.group-name {
  margin-right: 1rem !important;
}
.color-input {
  display: flex;
  align-items: center;
}
.color-list {
  display: flex;
  flex-wrap: wrap;
  z-index: 100;
  background: white;
  position: absolute;
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
  border: none;
  left: 0;
  top: 3.5;
  box-shadow: 0px 0px 2px 2px #eee;
  margin-top: 0.5rem;
  // grid: repeat(2, 3rem) / auto-flow 3.2rem;
  .fa {
    display: block;
    cursor: pointer;
    margin: 0.5rem;
  }
}
.eye-icon {
  margin-right: 1rem;
}

.svg-on-hover {
  svg {
    display: none;
  }
  &:hover {
    svg {
      display: block;
    }
  }
}
.list-card__body--item-text {
  .fa-plus {
    padding-left: 0.8rem;
  }
  .field {
    padding-left: 0rem;
  }
}
.list-card__body {
  padding-bottom: 1.5rem;
}
</style>
